import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApidataService } from 'src/app/apidata.service';

interface Service {
  servicesUrl: string;
  navbartext: string;
  other: string;
  serviceimage: string | null;
  pagesubcategory: string;
  pagecategory: string;
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  patientlistLoader = false;
  ContactlistLoader = false;
  loading: boolean = true;
  services: Service[] = [];
  categorizedServices: { [key: string]: Service[] } = {};
  errorMessage!: string;

  constructor(private service: ApidataService, private router: Router) {}

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.getallnavbar();
  }

  classToggled = false;
  public toggleField() {
    this.getallnavbar();
    this.classToggled = !this.classToggled;  
  }

  viewDetail(id: string) {
    // Jobdetail/:id
    this.router.navigate(['Jobdetail', id]);
  }

  getallnavbar(): void {
    this.service.navbargetall().subscribe(
      (res) => {
        this.loading = false;
        if (res.status) {
          this.services = res.data;
          this.filterServices();

        } else {
          // Handle error scenario
        }
      },
      (error: any) => {
        this.errorMessage = error as any;
        this.loading = false;
      }
    );
  }
  itServices: Service[] = [];
  clinicalDataServices: Service[] = [];
  Education: Service[] = [];
  Training: Service[] = [];
  filterServices() {
    this.itServices = this.services.filter(service => service.pagesubcategory === 'IT-Services');
    this.clinicalDataServices = this.services.filter(service => service.pagesubcategory === 'Clinical-Data');
    this.Education = this.services.filter(service => service.pagesubcategory === 'Education');
    this.Training = this.services.filter(service => service.pagesubcategory === 'Training');


  }

  
}
